
export class HealthOrganizationData {
  name: string;
  webAddress: string;
  phoneNumber: string;
  line: string;
  line2: string;
  city: string;
  state: string;
  zipCode: string;
  isCertify: boolean;
  isAcceptedTermsConditions: boolean;
  isAcceptedBaa: boolean;
  endOfTrialDate: Date;
  isProfileSetUpCompleted: boolean;
  healthOrganizationTypeId:number;
}
